import { on } from "delegated-events";
import { gsap } from "gsap";

const headerSlider = document.querySelector(".header-circle-slider");

class HeaderCircle {
  constructor() {
    this.iconCircle = headerSlider.querySelector(".slide-icons");
    this.icons = this.iconCircle.querySelectorAll(".slide-icon");
    this.totalIcons = this.icons.length;
    this.activePos = Math.ceil(this.totalIcons / 2);
    this.tickInterval = null;

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(this.setSize.bind(this));
    });

    resizeObserver.observe(document.body);

    this.setSize();
    this.activateIcon();
    this.start();

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        this.start();
      } else {
        this.stop();
      }
    });

    on("click", ".header-circle-slider .slide-icon", (e) => {
      const target = e.target.closest(".slide-icon");
      const pos = parseInt(target.dataset.pos);

      if (pos === this.activePos) {
        return;
      }

      this.stop();

      let tickAmount = Math.abs(pos - this.activePos);

      if (pos > this.activePos) {
        tickAmount = this.totalIcons - (pos - this.activePos);
      }

      this.tick(tickAmount);
      this.start();
    });
  }

  start() {
    this.stop();

    this.tickInterval = setInterval(() => {
      this.tick();
    }, 5000);
  }

  stop() {
    clearInterval(this.tickInterval);
  }

  setSize() {
    this.icons.forEach((icon) => icon.classList.add("is-resetting"));
    this.iconCircle.offsetHeight;
    this.iconCircle.style.setProperty("--radius", `${headerSlider.getBoundingClientRect().width / 2}px`);
    this.icons.forEach((icon) => icon.classList.remove("is-resetting"));
  }

  activateIcon() {
    gsap.to(`.slide-content`, { opacity: 0, yPercent: -50, duration: 0.8 });

    this.icons.forEach((icon) => {
      const pos = parseInt(icon.dataset.pos);

      if (pos === this.activePos) {
        icon.setAttribute("aria-selected", "true");
        icon.classList.add("pointer-events-none");

        gsap
          .timeline({ delay: 0.5 })
          .to(icon.querySelector(".slide-icon-wrapper"), { scale: 1.75 })
          .to(icon.querySelector(".slide-icon-inner"), { opacity: 1 }, "<")
          .to(icon, { duration: 0, onComplete: () => icon.classList.add("is-active") }, "<50%")
          .fromTo(
            `.slide-content[data-id="${icon.dataset.id}"]`,
            { opacity: 0, yPercent: 20 },
            { opacity: 1, yPercent: 0, duration: 0.8 },
          );
      } else {
        icon.setAttribute("aria-selected", "false");
        icon.classList.remove("pointer-events-none");

        gsap
          .timeline({ delay: 0.5 })
          .to(icon.querySelector(".slide-icon-wrapper"), { scale: 1 })
          .to(icon.querySelector(".slide-icon-inner"), { opacity: 0 }, "<")
          .to(icon, { duration: 0, onComplete: () => icon.classList.remove("is-active") }, "<50%");
      }
    });
  }

  tick(offset = 1) {
    this.iconCircle.classList.add("is-transitioning");

    this.icons.forEach((icon) => {
      const pos = parseInt(icon.dataset.pos);
      const stylePos = parseInt(getComputedStyle(icon).getPropertyValue("--pos"));

      const nextPos = pos + offset;
      const nextRealPos = nextPos % this.totalIcons === 0 ? this.totalIcons : nextPos % this.totalIcons;

      icon.dataset.pos = nextRealPos;

      let nextStylePos = stylePos + offset;

      if (nextStylePos > this.totalIcons) {
        nextStylePos = nextStylePos + this.activePos;

        setTimeout(() => {
          icon.classList.add("is-resetting");
          icon.style.setProperty("--pos", nextRealPos);
          icon.offsetHeight;
          icon.classList.remove("is-resetting");
          this.iconCircle.classList.remove("is-transitioning");
        }, 1500);
      }

      icon.style.setProperty("--pos", nextStylePos);
    });

    this.activateIcon();
  }
}

if (headerSlider) {
  new HeaderCircle();
}
